import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function FailedSolutions() {
  const solutions = ['El café en exceso solo agota tus glándulas adrenales, dándote ansiedad en lugar de energía real.', 'El ejercicio extenuante después de un día estresante eleva el cortisol a niveles que impiden la recuperación celular.', 'Las dietas restrictivas y el ayuno mal ejecutado le dicen a tu cuerpo que hay una "famine", obligándolo a ralentizar aún más tu metabolismo.', 'Los suplementos de moda no funcionan porque intentas llenar un cubo que tiene tres agujeros biológicos en el fondo.', 'El descanso pasivo (sofá y TV) no recarga tu batería mitocondrial; a menudo profundiza el estado de hibernación.'];
  return <section className="py-24 relative overflow-hidden" data-id="element-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-19">
            Lo que has intentado no funciona porque ataca los síntomas,{' '}
            <span className="text-coral-400 text-[#ff6b6b]" data-id="element-20">no la causa.</span>
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-21">
          {solutions.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex items-start gap-4 bg-white/[0.02] p-6 rounded-xl border border-white/5" data-id="element-22">
              <div className="mt-1 bg-red-500/10 p-1 rounded-full shrink-0" data-id="element-23">
                <XIcon className="w-5 h-5 text-[#ff6b6b]" data-id="element-24" />
              </div>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-25">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}